export const NAV_UFORE_URL = 'https://www.nav.no/uforetrygd';
